define('home/views/ChannelMetadataView',[
    'underscore',
    'backbone-marionette',
    'handlebars',

    'core/strings',

    'home/views/ChannelLeadersModuleView',
    'home/mixins/withChannelAvatar',
    'core/mixins/withChannelFollowing',
    'home/mixins/withCollapsing',
    'home/mixins/withLoginOverlay',

    'home/templates/channelMetadata',
], function (
    _,
    Marionette,
    Handlebars,

    strings,

    ChannelLeadersModuleView,
    withChannelAvatar,
    withChannelFollowing,
    withCollapsing,
    withLoginOverlay,

    channelMetadataTemplate
) {
    'use strict';

    var gettext = strings.get;

    var ChannelMetadataView = Marionette.Layout.extend({
        regions: {
            leadersRegion: '[data-role=leaders]',
        },

        template: channelMetadataTemplate,
        templateHelpers: function () {
            var primaryForum = this.model.channel.primaryForum;
            var numThreads = primaryForum.get('numThreads');
            var numFollowers = primaryForum.get('numFollowers');
            return {
                // Attributes may be null during fetch
                numThreads: numThreads && numThreads.toLocaleString(),
                numFollowers: numFollowers && numFollowers.toLocaleString(),
            };
        },

        initialize: function () {
            this.listenTo(this.model.channel, 'sync', this.render);
            this.bindToPrimaryForum();
        },

        bindToPrimaryForum: function () {
            if (!this.model.channel.primaryForum) {
                this.listenToOnce(this.model.channel, 'changeRelated:primaryForum', this.bindToPrimaryForum);
                return;
            }

            // Only rerender stats area of the view when numbers change so that the leaders module won't rerender
            // and lose state (ex: expanded, active tab)
            this.listenTo(this.model.channel.primaryForum,
                'change:numFollowers change:numThreads',
                this.renderStats);
        },

        renderStats: function () {
            var data = this.serializeData();
            data = this.mixinTemplateHelpers(data);
            this.$('[data-role=stats]').html(Handlebars.partials.channelMetadataStats(data));
        },

        onDomRefresh: function () {
            var boundShowLeadersModule = _.bind(this.showLeadersModule, this);
            this.model.ensureFetchedLeaders().then(boundShowLeadersModule);
            this.model.ensureFetchedModerators().then(boundShowLeadersModule);
            this.leadersRegion.show(new ChannelLeadersModuleView({ model: this.model }));
        },

        // Experts section is hidden until at least 1 expert is added, so that the
        // labels and expand links don't show for empty expert lists
        showLeadersModule: function () {
            if (this.model.leaders.items.length || this.model.moderators.items.length)
                this.$('[data-role=leaders]').removeClass('hidden');
        },
    });

    withChannelFollowing.call(ChannelMetadataView.prototype, function () {
        return this.model.channel;
    });

    withChannelAvatar.call(ChannelMetadataView.prototype, function () {
        return this.model.channel;
    });

    withCollapsing.call(ChannelMetadataView.prototype, {
        maxHeight: 200, // px
        collapsibleSelector: '[data-role=guidelines-section]',
    });

    withLoginOverlay.call(ChannelMetadataView.prototype,
        strings.interpolate(
            gettext('Join %(disqus)s to start your own channel like this one.'),
            { disqus: 'Disqus' }
        ));

    return ChannelMetadataView;
});

